const INITIAL_STATE = {
  isLoading: false,
  error: null,
  secondLoaders: false,
};

export const errorReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "DATA_FETCHING":
      return { ...state, isLoading: true, error: null };

    case "CREATE_LOADS":
      return { ...state, isLoading: false, secondLoaders: true, error: null };

    case "SUCCESS":
      return {
        ...state,
        isLoading: false,
        error: null,
        secondLoaders: false,
      };

    case "IS_ERROR":
      return {
        ...state,
        isLoading: false,
        secondLoaders: false,
        error: action.payload,
      };
    case "CLEAN_STATE":
      return {
        ...state,
        isLoading: false,
        secondLoaders: false,
        error: null,
      };

    default:
      return state;
  }
};
